// extracted by mini-css-extract-plugin
module.exports = {"messageBubble":"MessageBubble_messageBubble__0mzCY","tail":"MessageBubble_tail__p0e_j","sender":"MessageBubble_sender__zmNDn","replier":"MessageBubble_replier__lELnZ"};